<template>
  <div class="drop">
    <v-layout justify-center align-content-center align-center column>
      <v-icon color="#ED722F" size="75" style="padding-right: 10px"
        >mdi-account</v-icon
      >
      <h2 style="color: #00558c">Authentication Failure</h2>
      <v-card-subtitle
        >Your authentication token is not valid or has expired.</v-card-subtitle
      >
      <!-- <v-card-subtitle>
        Please click
        <a @click="$router.push('/')">here</a> to be redirected.
      </v-card-subtitle> -->
    </v-layout>
  </div>
</template>
<script>
import EventBus from "@/eventBus.js";

export default {
  created() {},
  mounted() {
    let jwt = window.sessionStorage.getItem("jwt");
    if (jwt != "invalid_jwt") {
      if (!window.sessionStorage.getItem("jwt")) {
        EventBus.$emit("setIsAuthenticated", false);
        EventBus.$emit("setIsJWTAuthenticated", false);
      }
    }
  },
};
</script>
<style scoped>
.drop {
  margin-top: 150px;
}
</style>